import { AddressFields } from '../graphql/athena/types/AddressFields';

export const prettifyStreetAddress = (address: AddressFields) => {
  return `${address.street} ${address.unitType} ${address.unitNumber}`.trim();
};

export const prettifyCityStateZip = (address: AddressFields) => {
  return `${address.city}, ${address.state} ${address.postalCode}`.trim();
};

export const prettifyAddress = (addr: AddressFields | null) => {
  if (!addr) {
    return 'Could not find address';
  }
  const street = prettifyStreetAddress(addr);
  return `${street}, ${addr.city}, ${addr.state} ${addr.postalCode}`;
};
